import {useParams} from 'react-router-dom';
import {EntityShiftsRepository} from '../repositories/entity-shifts';
import {useFetchAllItems} from './fetch-all-items';

export type FetchShifts = {
  enabled?: boolean;
};

export function useFetchShifts(opts?: FetchShifts) {
  const {entityId} = useParams<{entityId: string}>();
  const {items, isLoading, error} = useFetchAllItems({
    fetchFunction: ({limit, skip}) => {
      return EntityShiftsRepository.instance.getShifts(entityId, limit, skip);
    },
    deps: [entityId],
    enabled: opts?.enabled,
  });

  return {
    items,
    isLoading,
    error,
  };
}
